module.exports = __webpack_public_path__ + "img/AramMohamad.74102921.jpg";